import React, { useState } from 'react';
import { howToFile, howToDiscipline, UNCONFIRMED_TEXT } from '../data/claimHowTo';
import { AGREEMENT_UNCONFIRMED_TEXT } from '../data/agreementStatus';   // ruling 324 (section 760)

// THE STEP-BY-STEP HOW-TO (Bob, 2026-10-15): for every claimant and every discipline case, how to complete it and
// submit it under THEIR agreement. Everything shown is projected by src\data\claimHowTo.js from the cited record;
// this component adds no fact. kind = 'claim' | 'discipline'. Collapsed to its title until opened, so it never
// pushes the form down; an agreement the platform does not hold says so plainly.
const C = { card: '#0D1B2A', head: '#E8A020', text: '#D8E2EE', line: '#8AA4BF', border: '#2E6B4A', warn: '#C08A2E' };

// audience ('member' | 'officer') is for discipline only: a member is told to give the letter to his Local
// Chairperson; only an officer, who holds the New Case door, is told to open the case.
export default function HowToPanel({ kind, agreement, service, defaultOpen, audience }) {
  const [open, setOpen] = useState(!!defaultOpen);
  if (!agreement) return null;
  const h = kind === 'discipline' ? howToDiscipline(agreement, audience) : howToFile(agreement, service);
  const title = kind === 'discipline' ? 'How a discipline case works under your agreement' : 'How to complete and file this claim, step by step';

  return (
    <div className="card" style={{ background: C.card, borderLeft: `4px solid ${C.border}`, marginBottom: 14 }}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open}
        style={{ all: 'unset', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <span className="card-title">{title}</span>
        <span style={{ color: C.head, fontSize: 12, fontWeight: 700 }}>{open ? 'Hide' : 'Show'}</span>
      </button>
      {open && (
        <div style={{ marginTop: 8 }}>
          {!h.recorded ? (
            <div style={{ fontSize: 12.5, color: C.warn }}>{h.text}</div>
          ) : (
            <>
              <div style={{ fontSize: 11, color: C.head, fontWeight: 600, marginBottom: 8 }}>
                {kind === 'discipline' ? agreement : h.claimsRule + ' · ' + agreement}
              </div>
              {/* Ruling 324 (section 760): the claim steps rest on the agreement, which no General Chairman has yet confirmed. */}
              {kind !== 'discipline' && (
                <div style={{ fontSize: 12, color: C.warn, border: `1px solid ${C.warn}`, borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
                  {AGREEMENT_UNCONFIRMED_TEXT}
                </div>
              )}
              {kind === 'discipline' && !h.confirmed && (
                <div style={{ fontSize: 12, color: C.warn, border: `1px solid ${C.warn}`, borderRadius: 6, padding: '6px 10px', marginBottom: 10 }}>
                  {UNCONFIRMED_TEXT}
                </div>
              )}
              <ol style={{ margin: 0, paddingLeft: 20 }}>
                {h.steps.map((s) => (
                  <li key={s.n} style={{ marginBottom: 10, color: C.text }}>
                    <div style={{ fontSize: 13, fontWeight: 700 }}>{s.title}</div>
                    {s.body.map((b, i) => (
                      <div key={i} style={{ fontSize: 12.5, lineHeight: 1.5, paddingLeft: b.startsWith('- ') ? 8 : 0 }}>{b}</div>
                    ))}
                    {s.cite && <div style={{ fontSize: 10.5, color: C.line, fontStyle: 'italic', marginTop: 2 }}>Source: {s.cite}</div>}
                  </li>
                ))}
              </ol>
            </>
          )}
        </div>
      )}
    </div>
  );
}
